import * as NavConstants from 'constants/NavConstants';
import preferences from 'Preferences';
import {isBLASTSort, isChemicalSimilaritySort, isRelevanceSort} from 'search/SortUtil';
import ImmutableSet from 'util/ImmutableSet';

import {
  Filter,
  FilterKey,
  SAVED_SEARCH_PREFERENCE,
  SEARCH_FILTER_PREFERENCE,
  Sort,
  SortKey,
  SortPreferences,
} from './SearchConstants';

export function getAppliedSortsFromUserPreference(section: NavConstants.Section): Array<Sort> {
  const sorts = preferences.get(getUserPreferenceSortsKey(section));
  // TODO: remove this filter once script to remove chemical similarity sort preferences has been run.
  return (
    sorts?.filter(
      (sort: Sort) => sort.key !== SortKey.SORT_CHEMICAL_SIMILARITY && sort.key !== SortKey.SORT_BLAST_E_VALUE
    ) ?? []
  );
}

export function rememberAppliedSortsToUserPreference(
  section: NavConstants.Section,
  sorts: Array<Sort>
): void {
  if (!isRelevanceSort(sorts) && !isChemicalSimilaritySort(sorts) && !isBLASTSort(sorts)) {
    preferences.set(getUserPreferenceSortsKey(section), sorts);
  }
}

export function getAppliedFiltersFromUserPreference(section: NavConstants.Section): Array<Filter> {
  return preferences.get(getUserPreferenceFiltersKey(section)) ?? [];
}

export function rememberAppliedFiltersToUserPreference(
  section: NavConstants.Section,
  filters: Array<Filter>,
  filterTypesToRemember: Array<FilterKey>
): void {
  const filtersToRememberSet = new ImmutableSet<FilterKey>(filterTypesToRemember);
  const filteredFilters = filters.filter(
    (filter) => filterTypesToRemember == null || filtersToRememberSet.has(filter.key)
  );
  preferences.set(getUserPreferenceFiltersKey(section), filteredFilters);
}

function getUserPreferenceSortsKey(section: NavConstants.Section): string {
  return `${SortPreferences.SORTS_NAMESPACE}${section}`;
}

function getUserPreferenceFiltersKey(section: NavConstants.Section): string {
  return `${SEARCH_FILTER_PREFERENCE}${section}`;
}

export function getSavedSearchPreferenceKey(section: NavConstants.Section): string {
  return `${SAVED_SEARCH_PREFERENCE}${section}`;
}
